import { createAsyncThunk } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import type { Config, PaginaDeExecucoes, PaginaDePassos } from '../../types';
import { paraErroDaSimulacao, registrarFalha } from '../falhasDaSimulacao';
import { selectEstadoDaSimulacao as estadoDaFeature } from '../selectors';
import { simulacaoAdminService } from '../services';

/** Os logs são só da superfície ADMIN e só da simulação que a tela mostra (CA-7). */
const temSimulacaoDoAdmin = (state: RootState) => {
  const { superficie, simulacao } = estadoDaFeature(state);
  return superficie === 'ADMIN' && simulacao !== null;
};

/** `cursor` nulo relê a primeira página; com cursor, é o "Carregar mais". */
export const buscarExecucoes = createAsyncThunk<
  { simulacaoId: string; pagina: PaginaDeExecucoes },
  { cursor: string | null },
  Config
>(
  'negociacaoSimulacao/buscarExecucoes',
  async ({ cursor }, { getState, rejectWithValue }) => {
    const simulacaoId = estadoDaFeature(getState()).simulacao?.id ?? '';
    try {
      return {
        simulacaoId,
        pagina: await simulacaoAdminService.buscarExecucoes(simulacaoId, cursor),
      };
    } catch (erro) {
      const falha = paraErroDaSimulacao(erro);
      registrarFalha('buscarExecucoes', erro, falha, { simulacaoId });
      return rejectWithValue(falha);
    }
  },
  { condition: (_, { getState }) => temSimulacaoDoAdmin(getState()) },
);

export const buscarPassos = createAsyncThunk<
  { simulacaoId: string; execucaoId: string; pagina: PaginaDePassos },
  { execucaoId: string; page: number },
  Config
>(
  'negociacaoSimulacao/buscarPassos',
  async ({ execucaoId, page }, { getState, rejectWithValue }) => {
    const simulacaoId = estadoDaFeature(getState()).simulacao?.id ?? '';
    try {
      const pagina = await simulacaoAdminService.buscarPassos(simulacaoId, execucaoId, page);
      return { simulacaoId, execucaoId, pagina };
    } catch (erro) {
      const falha = paraErroDaSimulacao(erro);
      registrarFalha('buscarPassos', erro, falha, { simulacaoId });
      return rejectWithValue(falha);
    }
  },
  { condition: (_, { getState }) => temSimulacaoDoAdmin(getState()) },
);
